import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  PLATFORM_ID,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { ITabsNavigation } from '../../../_interfaces/tab-navigation.interface';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AnimationsEnum } from '../../../_enums/animations.enum';
import { BrandsEnum } from '../../../_enums/brands.enum';
import { CoreModalService } from '../../modals/core-modal/core-modal.service';
import { SdDropdownComponent } from '../../dropdowns/dropdown/dropdown.component';
import { SdIconComponent } from '../../icons/icon/icon.component';
import { SdLibConfig } from '../../../sd-lib-config';
import { SdListComponent } from '../../lists/list/list.component';

@Component({
  selector: 'sd-tab-navigation',
  templateUrl: './tab-navigation.component.html',
  standalone: true,
  imports: [
    SdListComponent,
    RouterLink,
    RouterLinkActive,
    SdIconComponent,
    SdDropdownComponent
  ]
})
export class SdTabNavigationComponent implements AfterViewInit, OnChanges {
  @Input()
  brand: BrandsEnum;

  @Input()
  selectedTabIndex = 0;

  @Input()
  items: ITabsNavigation[];

  @ViewChild('activeBar', { read: ElementRef })
  activeBar: ElementRef;

  @ViewChildren('tabList')
  tabList: QueryList<ElementRef>;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.animation ? 'is-animation-' + this.animation : '']
      .filter(Boolean)
      .join(' ');
  }

  tabSelected: HTMLElement;
  animation!: AnimationsEnum;
  animationEnum = AnimationsEnum;

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private coreModalService: CoreModalService,
    private el: ElementRef,
    private sdLibConfig: SdLibConfig,
    private renderer: Renderer2,
  ) {}

  close() {
    this.coreModalService.closeAllModal();
  }

  selectTab(index) {
    this.tabSelected = this.tabList.toArray()[index].nativeElement;
    this.activeBarPosition(
      this.tabSelected.offsetWidth,
      this.tabSelected.offsetLeft,
    );
  }

  ngAfterViewInit() {
    if (
      isPlatformBrowser(this.platformId) &&
      this.animation === AnimationsEnum.slide
    ) {
      setTimeout(() => {
        this.renderer.setStyle(this.activeBar.nativeElement, 'opacity', 1);
        this.tabSelected =
          this.tabList.toArray()[this.selectedTabIndex].nativeElement;
        this.activeBarPosition(
          this.tabSelected.offsetWidth,
          this.tabSelected.offsetLeft,
        );
      });
    }
  }

  ngOnChanges() {
    this.animation = this.sdLibConfig.get(this.brand).animation;
  }

  activeBarPosition(width, posX) {
    this.renderer.setStyle(this.activeBar.nativeElement, 'width', width + 'px');
    this.renderer.setStyle(this.activeBar.nativeElement, 'left', posX + 'px');
    this.renderer.setStyle(this.activeBar.nativeElement, 'opacity', 1);
  }
}
